import product1 from '../Image/kue 1.jpg';
import product2 from '../Image/kue 2.jpg';
import product3 from '../Image/kue 3.jpg';
import product4 from '../Image/kue4.jpg';
import product5 from '../Image/kue5.jpg';
import product6 from '../Image/kue6.jpg';
import product7 from '../Image/kue7.jpg';
import product8 from '../Image/kue8.jpeg';
import product9 from '../Image/kue9.jpg';
import product10 from '../Image/kue10.jpg';
import product11 from '../Image/kue11.jpg';
import product12 from '../Image/kue12.jpg';

export const productData = [
  {
    img: product1,
    alt: 'kue 1',
    name: 'kue ultah 1',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product2,
    alt: 'kue 2',
    name: 'kue ultah 2',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product3,
    alt: 'kue 3',
    name: 'kue ultah 3',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product4,
    alt: 'kue 4',
    name: 'kue ultah 4',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product5,
    alt: 'kue 5',
    name: 'kue ultah 5',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product6,
    alt: 'kue 6',
    name: 'kue ultah 6',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product7,
    alt: 'kue 7',
    name: 'kue ultah 7',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product8,
    alt: 'kue 8',
    name: 'kue ultah 8',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product9,
    alt: 'kue 9',
    name: 'kue ultah 9',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product10,
    alt: 'kue 10',
    name: 'kue ultah 10',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product11,
    alt: 'kue 11',
    name: 'kue ultah 11',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  },
  {
    img: product12,
    alt: 'kue 12',
    name: 'kue ultah 12',
    desc: 'mas rangga buat desc rasa dan nama unik dr gmbr kue ini',
    button: 'add to Cart'
  }
];
